<template>
    <Modal modal-name="delivery-modal" modal-class="modal-deliveries" :title="$t('deliveries.title')" @shown="fetchDeliveries">
        <ObjectsDelivery v-if="productId" ref="deliveries" :product-id="productId" />
        <ObjectsDelivery v-else ref="deliveries" />
    </Modal>
</template>

<script lang="ts" setup>
const productId = ref<number | null>(null)
const deliveries = ref<{ loading: boolean; fetch: Function } | null>(null)

onMounted(() => {
    useNuxtApp().$bus.$on('showDeliveryModal', (id: number | null) => {
        productId.value = id
        useNuxtApp().$bus.$emit('showModal', 'delivery-modal')
    })
})

const fetchDeliveries = () => {
    if (!deliveries.value) {
        return
    }

    useNuxtApp().$bus.$emit('refreshDeliveries')
}
</script>
